const getFlag = (country: string) => {
    return `https://flagcdn.com/${country}.svg`
}

export { getFlag }
